import ErrorAlert from './ErrorAlert';
import { ApiError } from '../apiClient/types';
import { generateMailtoLinkForErrorOnScreen } from '../lib/generateMailtoLink';
import { useNavigate } from 'react-router-dom';

interface ApiErrorAlertProps {
  screenName: string;
  apiError: ApiError | null;
  clearError: (_: null) => void;
}

const ApiErrorAlert = ({ screenName, apiError, clearError }: ApiErrorAlertProps) => {
  const navigate = useNavigate();
  return apiError ? (
    <ErrorAlert
      dialogTitle="An Error Occured"
      dialogMessage="Please try again. If this continues to happen email our team directly so we can help you book your experience."
      primaryButtonTitle="Email support"
      primaryButtonAction={() => {
        clearError(null);
        window.open(generateMailtoLinkForErrorOnScreen(screenName, apiError.requestId));
        navigate('/');
      }}
      secondaryButtonTitle="Try Again"
      secondaryButtonAction={() => {
        clearError(null);
      }}
      isOpen={apiError !== null}
    />
  ) : null;
};

export { ApiErrorAlert };
export type { ApiError };
